<template>
  <!-- 素材提取 -->
  <!-- todo  参考官网建设-资讯-发布 -->
  <div class="page-collect-search-photo">
    <div class="header">
      <h1 v-if="pageType=='add'">新增素材</h1>
      <h1 v-if="pageType=='edit'">编辑素材</h1>
      <h1 v-if="pageType=='detail'">查看素材</h1>
      <!-- <p>上传文物图片，自动提取素材</p> -->
    </div>

    <div class="sch-box">
      <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
        v-if="pageType!=='detail'">
        <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
        <div v-else>
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div class="el-upload__text">上传图片</div>
        </div>
      </el-upload>

      <div class="pic-box" v-if="pageType==='detail'">
        <img :src="imgUrl" alt="">
      </div>
      <!-- <el-upload style="z-index: 2;"
        ref="myUpload"
        class="upload-demo"
        action="/admin/search/searchPicture.do"
        :data="configData"
        :file-list="fileList"
        :limit="1"
        :auto-upload="false"
        list-type="picture"
        :on-success="handleAvatarSuccess"
        :on-change="handPic">
        <div class="btn-upload" v-show="pic" @click="handleClick"></div>
      </el-upload> -->

      <!-- <a class="btn-digital mt-10" @click="handleSearch" style="z-index: 2;">提取</a> -->
    </div>

    <div class="wrap">
      <div class="res">
        <h2>素材信息</h2>
      </div>

      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="素材名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="素材编号 :" prop="code">
              <el-input v-model="form.code" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="素材类型 :" prop="type">
              <el-select clearable v-model="form.type" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="8">
            <el-form-item label="来源编号 :" prop="sourceNumber">
              <el-input v-model="form.sourceNumber" placeholder="请输入"
                :disabled="pageType==='detail'" @change="handleChange"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="素材来源 :" prop="">
              <el-input v-model="detailData.collectName" placeholder="自动获取"
              disabled></el-input>
              <!-- <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          
          <el-col :span="8">
            <el-form-item label="类别 :" prop="">
              <el-input v-model="detailData.collectTypeText" placeholder="自动获取"
                disabled></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="8">
            <el-form-item label="年代 :" prop="">
              <el-input v-model="detailData.collectYearText" placeholder="自动获取"
                disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- <el-form-item label="创建时间 :" prop="title">
          <el-date-picker style="width: 100%;" v-model="form.createTime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间"></el-date-picker>
        </el-form-item> -->
      </el-form>
    </div>

    <div slot="footer" class="footer fr mt-30" v-if="pageType!=='detail'">
      <el-button @click="goBack">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">保存</el-button>
    </div>
    <div slot="footer" class="footer fr mt-30" v-if="pageType==='detail'">
      <el-button type="primary" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
// import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
import { mapGetters } from 'vuex'
export default {
  // components: { cmpUploadMainPhonto },
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {},
      typeList: [],
      dialogVisible: false,
      configData: {
        tableName: 'collect'
      },
      imgUrl: '',
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        code: [{ required: true, message: '必填', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'blur' }],
        sourceNumber: [{ required: true, message: '必填', trigger: 'blur' }],

        // scope: [
        //   { required: true, message: '必填', trigger: 'blur' },
        //   // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        // ],
        // title: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
      detailData: {}
    }
  },
  methods: {
    handleChange() {
      console.log(this.form.laiyuan)

      // 获取素材来源和年代 todo
      this.$http
        .get('/collection/getCollectionByCode', {
          code: this.form.sourceNumber
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
            // this.form = res.result
            // if (res.result.img) {
            //   this.imgUrl = res.result.imgUrl
            // }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSearch() {},
    // init(type, id) {
    //   this.dialogVisible = true
    //   // 清空弹框数据
    //   this.form = {}
    //   this.pageType = type // 页面类型
    //   this.detailId = id || '' // 详情id
    //   // 新增或编辑
    //   if (this.detailId) {
    //     this.getDetailData()
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.myCkeditor.initEditor()
    //     this.$refs['form'].clearValidate() // 清空验证状态
    //   })
    // },

    getDict() {
      this.$http
        .get('/collectDict/getSelectDataByKey', {
          key: 'material_type'
        })
        .then(res => {
          if (res.success) {
            this.typeList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 获取详情
    getDetailData() {
      this.$http
        .get('/collectmaterial/find', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            // this.form = data
            this.form = {
              id: data.id,
              attId: data.attId,
              name: data.name,
              code: data.code,
              sourceNumber: data.sourceNumber,
              type: data.type
            }
            if (res.result.materialPicture) {
              this.imgUrl = res.result.materialPicture
            }
            this.detailData.collectName = data.sourceName
            this.detailData.collectTypeText = data.typeDesc
            this.detailData.collectYearText = data.yearDesc
          } else {
            this.$message.error(res.message)
          }
        })
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        if (this.pageType == 'edit') {
          this.form.imgUrl = res.result.attPath
        }
        this.form.attId = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },

    // 保存
    fromSubmit(form) {
      // let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      // if (!content) {
      //   this.$message.warning('请输入内容')
      //   return
      // }
      if(!this.form.attId) {
        this.$message.warning('请上传图片')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          let apiUrl = `/collectmaterial/save`
          if(this.pageType === 'edit') {
            apiUrl = `/collectmaterial/update`
          }
          this.$http
            .post(apiUrl, {
              ...this.form,
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('创建成功')
                }
                this.goBack()

                this.cancel()
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    goBack() {
      this.$router.go(-1)
    },

    // 取消
    cancel() {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      // this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  },
  created() {
    this.getDict()
    // this.dialogVisible = true
    // 清空弹框数据
    this.form = {}
    this.pageType = this.$route.query.pageType // 页面类型
    this.detailId = this.$route.query.id || '' // 详情id
    // 新增或编辑
    if (this.detailId) {
      this.getDetailData()
    }
    this.$nextTick(() => {
      // this.$refs.myCkeditor.initEditor()
      this.$refs['form'].clearValidate() // 清空验证状态
    })
  }
}
</script>

<style lang="scss" scoped>
.page-collect-search-photo {
  width: 100%;
  padding: 50px 10%;
  box-sizing: border-box;
  background: #fff;
  overflow-y: auto;

  .header {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: solid 1px #e5e5e5;
    h1 {
      margin-bottom: 10px;
    }
  }

  .sch-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn-digital {
      display: inline-block;
      color: #fff;
      width: 186px;
      height: 36px;
      background: #000;
      background-size: 100% 100%;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    .pic-box {
      text-align: center;
      margin-bottom: 30px;
      img {
        max-width: 60%;
      }
    }
  }
  .avatar-uploader {
    width: 50%;
    border: 1px dashed #8c939d;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-upload {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  .res {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: solid 1px #e5e5e5;
  }

  .wrap {
    
    
  }
}
</style>

